import { useCurrentAsset } from '@/hooks/use-current-asset';

export function useCurrentSystemId(): string {
  const { assetId } = useCurrentAsset();

  return assetId!;
}
